import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axios";


const fetchLikeBlog = createAsyncThunk(
  "blog/likeBlog",
  async ({ id, likes }) => {
    try {
      const response = await axiosInstance.patch(`/blogs/${id}`, { likes: +likes + 1 });
      return response.data;
    } catch (error) {
      console.log("ERROR: ", error);
    }
  }
);

export default fetchLikeBlog;
